<template>
  <vs-popup id="popupSignField" title="서명" :active.sync="showPopup">
    <div>
      <!-- PC 버튼 레이아웃 -->
      <div v-if="!image && !readonly" class="hidden xl:flex justify-end gap-2 mb-2">
        <vs-button color="secondary" @click.prevent="handleClickLoad" >이미지업로드</vs-button>
        <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.undo()">실행취소</vs-button>
        <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.redo()">다시실행</vs-button>
        <vs-button color="secondary" @click.prevent="$refs.VueCanvasDrawing.reset()">초기화</vs-button>
      </div>

      <!-- 모바일 버튼 레이아웃 -->
      <div v-if="!image && !readonly" class="flex xl:hidden justify-center gap-1 mb-2 flex-wrap mobile-button-layout">
        <vs-button color="secondary" @click.prevent="handleClickLoad">업로드</vs-button>
        <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.undo()">취소</vs-button>
        <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.redo()">재실행</vs-button>
        <vs-button color="secondary" @click.prevent="$refs.VueCanvasDrawing.reset()">초기화</vs-button>
      </div>

      <div v-if="image" style="text-align: center;">
        <div class="sign-img" :style="{backgroundImage: `url(${image})`}"></div>
<!--        <img v-if="image" height="270" :src="image" style="display: inline-block; content: ''; border: 1px solid #cdcdcd;"/>-->
      </div>
      <div v-else-if="this.showPopup" class="canvas-container">
        <vue-drawing-canvas
          ref="VueCanvasDrawing"
          :image.sync="useImage"
          :width="canvasWidth"
          :height="canvasHeight"
          :lineWidth="8"
          stroke-type="dash"
          line-cap="round"
          line-join="round"
          :fill-shape="false"
          :eraser="false"
          color="#000000"
          background-color="transparent"
          saveAs="png"
          :styles="{ border: 'solid 1px #cdcdcd' }"
          :lock="readonly"
        />
      </div>

      <!-- PC 하단 버튼 -->
      <div v-if="!readonly" class="hidden xl:flex justify-end gap-2">
        <vs-button color="secondary" v-if="image" @click="handleDelete">삭제</vs-button>
        <vs-button v-if="image" @click="handleClickClose">닫기</vs-button>
        <template v-else>
          <vs-button @click="handleSave">적용</vs-button>
        </template>
      </div>

      <!-- 모바일 하단 버튼 -->
      <div v-if="!readonly" class="flex xl:hidden justify-center gap-2 mt-2">
        <vs-button color="secondary" v-if="image" @click="handleDelete">삭제</vs-button>
        <vs-button v-if="image" @click="handleClickClose">닫기</vs-button>
        <template v-else>
          <vs-button @click="handleSave">적용</vs-button>
        </template>
      </div>

      <input type="file" style="display: none;" ref="fileUpload" @change="readFile" />
<!--      <img ref="resizeImg" style="display: none;" height="270" @load="" />-->
    </div>
  </vs-popup>
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas";

export default {
  name: 'PopupSignField',
  components: {
    VueDrawingCanvas,
  },
  props: {
    value: Boolean,
    image: String,
    selectId: [String, Number],
    readonly: Boolean,
  },
  watch: {
    value (data) {
      this.showPopup = data
    },
    showPopup (data) {
      this.$emit('input', data)
    },
  },
  data () {
    return {
      showPopup: false,
      useImage: '',
    }
  },

  computed: {
    // 화면 크기에 따른 캔버스 크기 계산
    canvasWidth() {
      if (typeof window !== 'undefined') {
        // 모바일: 팝업 컨텐츠 영역에 맞게 조정 (327px 기준으로 여유 20px)
        if (window.innerWidth < 1280) {
          return Math.min(300, 570); // 팝업 내부에 맞게 최대 300px
        }
      }
      // PC: 기본 570px
      return 570;
    },
    canvasHeight() {
      if (typeof window !== 'undefined') {
        // 모바일: 너비 비율에 맞춰 높이 계산 (570:270 비율 유지)
        if (window.innerWidth < 1280) {
          const width = Math.min(300, 570);
          return Math.round((width * 270) / 570);
        }
      }
      // PC: 기본 270px
      return 270;
    }
  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false
        next(false); return
      }
      next(true)
    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },

  created () {
    this.showPopup = this.value
    this.oldSelectCompanyId = this.selectId
  },

  methods: {

    async loadCompanyList () {
      const page = this.page.current
      const perPage = this.page.perPage
      const keyword = this.search.keyword
      const projectId = this.projectId
      await this.$store.dispatch('company/LOAD_COMPANY_LIST', {
        page,
        perPage,
        keyword,
        projectId
      })

    },

    handleClickClose () {
      this.$emit('input', false)
      this.$emit('handleClickClose')
    },

    handleSave () {
      this.$emit("save", this.useImage)
      this.showPopup = false
    },

    handleDelete () {
      this.$emit("delete")
      this.showPopup = false
    },

    handleClickLoad() {
      this.$refs['fileUpload'].click();
    },
    // 파일이 불려진 이후 실행
    readFile(data) {
      const file = data.target.files[0];

      if (file.type.includes('image')) {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          img.onload = () => {
            const targetWidth = this.canvasWidth;
            const targetHeight = this.canvasHeight;
            let newWidth = 0;
            let newHeight = 0;
            const imgRatio = img.width / img.height;
            const targetRatio = targetWidth / targetHeight;
            if (imgRatio > targetRatio) {
              newWidth = targetWidth;
              newHeight = (targetWidth * img.height / img.width);
            } else {
              newWidth = (targetHeight * img.width / img.height);
              newHeight = targetHeight;
            }
            canvas.width = newWidth;
            canvas.height = newHeight;

            console.log({newWidth, newHeight});

            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            const resized = canvas.toDataURL();

            this.$emit('update', resized);
          }
          img.src = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        // 이미지가 업로드 되지 않았으므로 무시한다
      }
    }
  }
}

</script>


<style>

#popupSignField > .vs-popup {
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none
}

</style>

<style scoped>
.sign-img {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  border: 1px solid #cdcdcd;
  margin-bottom: 10px;
}

/* PC 크기 */
@media (min-width: 1280px) {
  .sign-img {
    width: 570px;
    height: 270px;
  }
}

/* 모바일 크기 */
@media (max-width: 1279px) {
  .sign-img {
    width: 300px;
    height: calc(300px * 270 / 570);
    margin: 0 auto;
  }

  .canvas-container {
    display: flex;
    justify-content: center;
  }

  .mobile-button-layout::v-deep .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: 0.5em 0.8em;
  }
}
</style>
